<template>
  <div>
    <o-dropdown v-if="hasActions">
      <o-button flat outline icon="chevronDown" icon-after>
        {{ $t('general.actions') }}
      </o-button>

      <template #content>
        <o-dropdown-item v-for="(action, key) in actions" :key="key" @click="handleAction(key)">
          {{ action.title }}
        </o-dropdown-item>
      </template>
    </o-dropdown>

    <action-dialog ref="actionDialog" />
  </div>
</template>

<script setup lang="ts">
import ActionDialog from '@/components/integration/actions/Action.vue'

import {
  ODropdownItem,
} from '@/components/elements'

interface Props {
  integration: Record<string, any>
}

const props = defineProps<Props>()

const actionDialog = ref<any>()

const actions = computed(() => {
  return props.integration?.actions
})

const hasActions = computed(() => {
  return actions.value && Object.keys(actions.value).length > 0
})

const handleAction = (action: string) => {
  const integration = props.integration
  actionDialog.value.open({ integration, action })
}
</script>



